<!--
 * @Author: FengXiao
 * @Date: 2020-07-26 14:18:29
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-19 16:20:32
-->
<template>
	<div class="wanxiang-detail-page page-container" @click="selectBtn()" @contextmenu.prevent="selectBtn()">
		<video-player :datas="videoData" :speaker="speaker" :allowEvent.sync="playerAllowEvent" @playNext="focusChapter"
			:index="chapterIndex" :auto-play="true" ref="videoPlayer" controlslist="nodownload">
			<div class="right-area" slot="right-area">
				<div class="speaker-info-bl">
					<div class="wanxiang-speaker-info-wrap">
						<div class="speaker-info">
							<div class="speaker_avatar">
								<img class="speaker_avatar-img" :src="speaker.avatar" alt />
							</div>
							<div class="speaker_name">{{ speaker.name }}</div>
							<div class="speaker_intro">{{ speaker.intro }}</div>
							<div class="speaker_rank">一席第{{ speaker.rank }}位演讲者</div>
						</div>
						<div class="actions-bl">
							<div class="collectio_btn" @click.stop="collect" :class="{ active: isCollection }"
								v-if="!isColumn">
								<img class="collectio_btn-icon" :src="heartIcon" />
								<span>{{ isCollection ? '已收藏' : '收藏' }}</span>
							</div>
							<div class="gift_btn" @click.stop="giving">
								<img src="../assets/icon/gift.svg" alt="" class="gift_btn-icon" />
								<span>赠送</span>
							</div>
						</div>
					</div>
				</div>
				<template v-if="!needPay && chapters.length && !isColumn">
					<div class="episodes-title">分集目录</div>
					<div class="episodes" :class="{ hasActions: pageData.show_pay !== 0 }">
						<div v-for="(item, index) in chapters" :key="item.id" class="episode-title"
							:class="{ active: chapterIndex === index }" @click.stop="onSelectChapter(index)"
							:ref="`episode-title-${index}`">
							<span> {{ index + 1 }}、{{ item.title }} </span>
							<span class="episode-time" :class="{ hasOmit: item.title.length > 32 }">
								<span class="omit" v-if="item.title.length > 32">...</span>
								{{ item.video_duration }}
							</span>
						</div>
					</div>
				</template>
				<div class="video-actions-bl" v-if="pageData.show_pay !== 0">
					<button class="buy_class-btn" @click="btnAction()">
						{{ buyBtnText }}
					</button>
				</div>
			</div>
		</video-player>
		<div class="content">
			<episode-list :title="episodeTitle" :datas="episodeList" :init-slide="initSlide" v-if="episodeList.length"
				@select="onSelectEpisode"></episode-list>
			<div class="container-wrap">
				<div class="left-bl" v-if="!isColumn">
					<transition name="el-fade-in-linear">
						<div class="child-bl" v-html="draft" v-show="miniTabActive[DOC_ID]"></div>
					</transition>
					<transition name="el-fade-in-linear">
						<comment-list class="child-bl" :topic="topic" type="wanxiang" :id="episodeId"
							v-show="!miniTabActive[DOC_ID]" @inputFocus="inputFocus"></comment-list>
					</transition>
				</div>
				<div class="left-bl" v-else>
					<div v-html="courseInfo"></div>
				</div>
				<div class="right-bl">
					<!-- <mini-tabs @onClickTab="onClickMiniTab" :active="miniTabActive" v-if="!isColumn"></mini-tabs> -->
					<div class="doc_btn" @click="openDoc" v-if="!isColumn">
						<img class="doc_btn-icon" :src="docIcon" />
						<span class="label" :class="{ active: miniTabActive[DOC_ID] }">
							{{ miniTabActive[DOC_ID] ? '关闭文稿' : '打开文稿' }}
						</span>
					</div>
					<recommend-videos :datas="recommendList" @click="onClickRecommend"></recommend-videos>
				</div>
			</div>
		</div>
		<pay-dialog v-model="payPopup" :options="payDialogOptions" :dialog-type="payDialogType"
			@showPayResult="showPayResult"></pay-dialog>
		<pay-result-dialog v-model="payResultVisible" :id="orderId" :type="payResOrderType"></pay-result-dialog>
	</div>
</template>

<script>
	import VideoPlayer from '@/components/AppVideoPlayer';
	import EpisodeList from '@/components/AppEpisodeList';
	import RecommendVideos from '@/components/AppRecommendVideos';
	// import MiniTabs from '@/components/AppMiniTabs';
	import CommentList from '@/components/AppCommentList';
	import PayDialog from '@/components/AppPayDialog';
	import PayResultDialog from '@/components/AppPayResultDialog';
	import requestApi from '@/service';

	import configFields from '@/utils/configFields';
	const {
		DOC_ID,
		HEART_ID,
		DRAFT_TYPE
	} = configFields;
	export default {
		name: 'WanXiangDetail',
		components: {
			VideoPlayer,
			EpisodeList,
			RecommendVideos,
			// MiniTabs,
			CommentList,
			PayDialog,
			PayResultDialog,
		},
		data() {
			return {
				playerAllowEvent: false, // 允许当前视频支持键盘事件
				pageData: {},
				videoData: {},
				speaker: {},
				episode: {},
				episodeList: [],
				recommendList: [], // 推荐列表
				miniTabActive: {}, // 推荐列表顶部tab 文稿 收藏
				topic: {}, // 评论顶部信息
				isColumn: 1, // 是否为万象栏目
				courseInfo: '', // 栏目状态时 富文本介绍
				draft: '', // 打开某个单独集时 富文本
				payPopup: false, // 支付弹窗
				orderItems: [], // 支付项目
				payDialogOptions: {},
				DOC_ID,
				episodeId: null,
				showBuyArticle: false, // 有实物
				orderId: '', // 订单id
				payResultVisible: false, // 支付结果
				payResOrderType: '', // 支付结果展示订单类型
				chapters: [], // 本集（小课）分集列表
				chapterIndex: 0, // 当前选中小节index
			};
		},
		mounted() {
			this.init();
			if (this.$route.params.oId) {
				this.showPayResult(this.$route.params.oId, this.$route.query.orderType);
			}
		},
		computed: {
			docIcon() {
				const iconName = this.miniTabActive[DOC_ID] ? 'doc-light' : 'doc';
				return require(`@/assets/imgs/icon/${iconName}.png`);
			},
			heartIcon() {
				return require(`@/assets/imgs/icon/${this.miniTabActive[HEART_ID] ? 'heart-light' : 'heart'}.png`);
			},
			needPay() {
				return this.pageData.pay_type !== 0 && this.pageData.already_bought === 0;
			},
			initSlide() {
				let index = 0;
				for (let i = 0; i < this.episodeList.length; i++) {
					if (this.episodeList[i].id === this.episodeId) {
						index = i;
						break;
					}
				}
				return index;
			},
			payDialogType() {
				let type = this.showBuyArticle ? 'article' : 'wanxiang';
				if (this.pageData.pay_type === 0 || this.pageData.show_pay === 1 || this.pageData.show_pay === 0) type =
					'vip';
				return type;
			},
			buyBtnText() {
				let text = '';
				switch (+this.pageData.show_pay) {
					case 1:
						text = '加入会员';
						break;
					case 2:
						text = '获取课程';
						break;
					case 3:
						text = '获取实物';
						break;
					default:
						break;
				}
				return text;
			},
			isCollection() {
				return this.miniTabActive[HEART_ID];
			},
		},
		watch: {
			$route(to) {
				if (to.path === '/wanxiang/detail') {
					this.init();
				}
			},
		},
		methods: {
			selectBtn() {
				// console.log("禁用右健")
			},
			init() {
				Object.assign(this.$data, this.$options.data());
				this.wanxiangId = +this.$route.query.id || '';
				this.episodeId = +this.$route.query.episodeId;
				this.isColumn = +this.$route.query.isColumn === 1;
				this.miniTabActive = {
					[DOC_ID]: false,
					[HEART_ID]: false,
				};
				this.refreshPage();
			},
			/**
			 * @description: 文稿
			 */
			openDoc() {
				if (this._riverClosure('docBtn', 800)) {
					if (!this.draft) {
						this.getDraft().then(res => {
							if (res) {
								this.miniTabActive[DOC_ID] = !this.miniTabActive[DOC_ID];
							}
						});
					} else {
						this.miniTabActive[DOC_ID] = !this.miniTabActive[DOC_ID];
					}
				}
			},
			/**
			 * @description: 收藏
			 */
			collect() {
				if (this.checkLogin() && this._riverClosure('collectionBtn', 800)) {
					requestApi(
						'/api/v1/wanxiang/collection/change/', {
							wanxiang_video_id: this.episodeId,
						},
						'POST'
					).then(() => {
						this.miniTabActive[HEART_ID] = !this.miniTabActive[HEART_ID];
					});
				}
			},
			/**
			 * @description: 赠送
			 */
			giving() {
				if (this._riverClosure('gavingBtn', 800)) {
					this.openPayPopup(true);
				}
			},
			refreshPage() {
				this.getData();
				this.getRecommend();
				if (this.isColumn) {
					this.getCourseInfo();
				}
				this.initScrollTop();
			},
			/**
			 * @description: 像首页、收藏、推荐进来的地方 由于没有wanxiangid 所以只能在等详情返回之后获取base里的wanxiangid 再去请求其他数据 啊 FML
			 */
			getData() {
				requestApi(`/api/site/wanxiang/${this.episodeId}/detail/`).then(({
					items,
					base
				}) => {
					console.log(base)
					if (!this.wanxiangId) {
						this.wanxiangId = base.id;
						this.getRecommend();
						if (this.isColumn) {
							this.getCourseInfo();
						}
					}
					this.pageData = base;
					this.speaker = base.speaker;
					this.episodeList = items;
					this.episodeTitle = base.title;
					const {
						chapters,
						cover,
						video_url,
						title,
						first_category,
						date,
						titlelanguage,
						is_collect
					} = this.getCurEpisode(items);
					this.videoData = {
						cover,
						videoUrls: video_url,
					};
					// console.log(this.videoData)
					if (chapters.length && !this.needPay) {
						this.chapters = chapters;
						this.chapterIndex = 0;
						this.videoData = chapters.map(item => {
							return {
								cover,
								videoUrls: item.video_distinct,
							};
						});
					}
					if (this.isColumn || this.needPay) {
						this.videoData = {
							cover: base.base_cover,
							videoUrls: [{
								type: 1,
								type_name: '标清',
								video_url: base.base_video,
							}, ],
						};
					} else {
						this.topic = {
							title,
							category: first_category,
							date,
							intro: titlelanguage,
						};
						this.miniTabActive[HEART_ID] = is_collect;
					}
					// 会员且显示实物购买
					this.showBuyArticle = base.already_bought === 1 && base.show_pay === 3;
				});
			},
			/**
			 * @description: 获取当前播放集
			 */
			getCurEpisode(data = this.episodeList) {
				return data.filter(item => item.is_current)[0];
			},
			/**
			 * @description: 获取演讲稿
			 */
			getDraft() {
				return new Promise(resolve => {
					requestApi('/api/site/draft/', {
						id: this.episodeId,
						type: DRAFT_TYPE.wanxiang,
					}).then(({
						draft
					}) => {
						if (draft) {
							this.draft = draft;
							resolve(true);
						} else {
							this.$message.error('未找到文稿');
							resolve(false);
						}
					});
				});
			},
			/**
			 * @description: 获取万象课程详情 展示的大图片
			 */
			getCourseInfo() {
				if (this.wanxiangId) {
					return new Promise(resolve => {
						requestApi(`/api/site/wanxiang/${this.wanxiangId}/course_intro/`, {
							id: this.recordId,
							type: DRAFT_TYPE.record,
						}).then(({
							course_info
						}) => {
							if (course_info) {
								this.courseInfo = course_info;
								resolve(true);
							} else {
								this.$message.error('未找到文稿');
								resolve(false);
							}
						});
					});
				}
			},
			inputFocus(val) {
				if (val) {
					this.playerAllowEvent = false;
				}
			},
			getRecommend() {
				if (this.wanxiangId) {
					const url = `/api/site/wanxiang/${this.wanxiangId}/recommend/`;
					requestApi(url).then(({
						recommended
					}) => {
						this.recommendList = recommended && recommended.length ? recommended : [];
					});
				}
			},
			/**
			 * @description: 选分集
			 */
			onSelectEpisode(data) {
				if (!this.needPay) {
					this.gotoWanXiangDetail(this.wanxiangId, data.id, 0);
				} else {
					this.$message.error('请先获得课程');
				}
			},
			// 选分集（章、小节）
			onSelectChapter(index) {
				this.chapterIndex = index;
			},
			/**
			 * @description: 打开支付弹窗
			 * isGaving: 是否是赠送
			 * pageData.show_pay：
			    0 正常展示
			    1 显示购买会员
			    2 显示购买课程
			    3 显示购买实物
			 */
			async openPayPopup(isGaving = false) {
				if (this.checkLogin()) {
					this.payDialogOptions = {
						wanxiangId: this.wanxiangId,
						payType: this.pageData.show_pay,
						isGaving,
					};
					this.payPopup = true;
				}
			},
			onClickRecommend(episodeId) {
				this.gotoWanXiangDetail('', episodeId);
			},
			gotoWanXiangDetail(id, episodeId, isColumn = 1) {
				this.$router.push({
					path: '/wanxiang/detail',
					query: {
						id,
						episodeId,
						isColumn,
					},
				});
			},
			// 429 news
			// 获取实物
			getArticle() {
				this.openPayPopup();
			},
			btnAction() {
				switch (+this.pageData.show_pay) {
					case 1:
					case 2:
						this.openPayPopup();
						break;
					case 3:
						this.getArticle();
						break;
					default:
						break;
				}
			},
			showPayResult(orderId, orderType) {
				this.orderId = orderId;
				this.payResOrderType = orderType;
				this.payResultVisible = true;
			},
			// 聚焦当前播放的这一集
			focusChapter(data, index) {
				this.chapterIndex = index;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.wanxiang-detail-page {
		.video-player-content .right-area {
			position: absolute;
			right: 0;
			top: 40px;
			height: calc(100% - 80px);
			max-height: 100%;
			box-sizing: border-box;
			padding: 40px 0 20px;

			.speaker-info-bl {
				display: block;
				flex: 1;
				padding: 0 24px;
			}

			.wanxiang-speaker-info-wrap {
				box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.25);

				.speaker-info {
					position: relative;
					display: flex;
					align-items: center;
					flex-direction: column;
					box-sizing: border-box;
					padding-bottom: 20px;
					width: 210px;
					max-width: 100%;
					margin: auto;
					border: none;

					.speaker_avatar {
						width: 56px;
						height: 56px;
						min-height: 56px;
						border-radius: 50%;
						overflow: hidden;
						margin: -28px 0 10px;
						display: flex;
						flex-direction: column;
						align-items: center;
						justify-content: center;
						filter: drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.25));
					}

					.speaker_name {
						margin-bottom: 8px;
						font-size: 15px;
						line-height: 15px;
						color: $C6;
					}

					.speaker_intro {
						font-size: 13px;
						color: $C4;
						line-height: 13px;
						margin-bottom: 8px;
						padding: 0 5px;
					}

					.speaker_rank {
						font-size: 13px;
						line-height: 13px;
						color: #bdbdbd;
					}
				}

				.actions-bl {
					display: flex;
					border-top: 1px solid #eee;

					.collectio_btn,
					.gift_btn {
						flex: 2;
						height: 36px;
						color: $C3;
						font-size: 14px;
						display: inline-flex;
						justify-content: center;
						align-items: center;
						cursor: pointer;

						&-icon {
							width: 15px;
							height: 15px;
							margin-right: 10px;
							vertical-align: middle;
						}
					}

					.collectio_btn {
						border-right: 1px solid #eee;

						&.active {
							color: $C13;
						}
					}
				}
			}

			.episodes-title {
				font-size: 12px;
				line-break: 14px;
				margin: 38px 0 10px;
				color: $C3;
				padding: 0 24px;
			}

			.episodes {
				font-size: 12px;
				line-height: 14px;
				color: $C3;
				overflow-y: auto;
				flex: 1;
				padding: 0 24px;
				margin-bottom: 15px;

				&.hasActions {
					margin-bottom: 35px;
				}

				.episode-title {
					background: $C10;
					color: $C3;
					width: 100%;
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 2;
					text-overflow: ellipsis;
					overflow: hidden;
					word-wrap: break-word;
					word-break: break-all;
					padding: 8px 15px;
					text-align: justify;
					margin-bottom: 5px;
					box-sizing: border-box;
					position: relative;
					cursor: pointer;

					&>span {
						max-height: 30px;
						display: block;
						position: relative;
						overflow: hidden;
					}

					&:last-child {
						margin-bottom: 0;
					}

					.episode-time {
						position: absolute;
						right: 15px;
						bottom: 8px;
						display: flex;
						align-items: center;
						justify-content: space-between;
						background: $C10;

						&.hasOmit {
							padding-left: 5px;
						}

						.omit {
							display: inline-block;
							margin-right: 20px;
						}
					}

					&.active {
						color: $C7;
					}
				}
			}
		}

		.video-actions-bl {
			position: relative;
			width: 100%;
			text-align: center;

			.buy_class-btn {
				border: none;
				outline: none;
				width: 120px;
				height: 50px;
				line-height: 50px;
				background: $C2;
				color: $C1;
				text-align: center;
				cursor: pointer;
				font-family: HYXinRenWenSongW;
				opacity: 0.9;

				&:hover {
					opacity: 1;
				}
			}
		}

		.content {
			.container-wrap {
				display: flex;
				align-items: flex-start;
				margin: 10px auto 100px;
			}

			.left-bl {
				width: 72%;
				max-width: 827px;
				margin-right: 10px;
				box-sizing: border-box;
				background: $C1;
				padding: 20px;
			}

			.right-bl {
				width: 28%;
				background-color: $C10;
			}
		}

		.doc_btn {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			height: 70px;
			background: $C1;
			cursor: pointer;
			user-select: none;
			margin-bottom: 5px;

			&-icon {
				width: 20px;
				height: 20px;
				margin-right: 10px;
				display: inline-block;
			}

			.label.active {
				color: $C2;
			}
		}
	}
</style>
